import React from 'react';
import { Layout } from 'htlib-copy';

import { string, exact, arrayOf, node } from 'prop-types';

import './InfoTable.scss';

const { Row, Column: Col } = Layout;

export default function InfoTable({ data }) {
  return (
    <div className="InfoTable">
      {data.map(({ label, value }) => (
        <div key={label} className="InfoTable__row">
          <Row>
            <Col wides={[{ wide: 4 }]} alignSelf="center">
              <p className="InfoTable__label">{label}</p>
            </Col>
            <Col wides={[{ wide: 8 }]} alignSelf="center">
              <div className="InfoTable__value">{value}</div>
            </Col>
          </Row>
        </div>
      ))}
    </div>
  );
}

InfoTable.propTypes = {
  data: arrayOf(exact({ label: string, value: node })).isRequired,
};
